import { render, staticRenderFns } from "./cfdeExplore.vue?vue&type=template&id=dcdcba22&scoped=true"
import script from "./cfdeExplore.vue?vue&type=script&lang=js"
export * from "./cfdeExplore.vue?vue&type=script&lang=js"
import style0 from "./cfdeExplore.vue?vue&type=style&index=0&id=dcdcba22&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdcba22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcdcba22')) {
      api.createRecord('dcdcba22', component.options)
    } else {
      api.reload('dcdcba22', component.options)
    }
    module.hot.accept("./cfdeExplore.vue?vue&type=template&id=dcdcba22&scoped=true", function () {
      api.rerender('dcdcba22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/cfdeExplore.vue"
export default component.exports